/**
 * This is actually the Resolution type which is different 
 * from the DocumentType actually used for the resolution.
 */
export enum ResolutionDocumentType {
  ExpertOpinion = 1,
  ExecutionResolution = 2,
  OtherLegalEntityLocation = 3,
  UnlockRequestASOO = 4,
  UnlockRequestMZO = 5,
  CommitteeMembership = 6,
  InspectionReport = 7,
  OtherLegalEntityLocationDecision = 8,
  ForeignLanguageDecision = 9,
  HarmonizationDecisionASOO = 10,
  // HarmonizationDecisionMZO = 11,
  ArchiveASOO = 12,
  ArchiveMZO = 13,
  ExpertOpinionCorrection = 14,
  ExecutionResolutionCorrection = 15,
  OtherLocationDecision = 16,
  InstitutionBasicDataChangeResolution = 17,
  HarmonizationUnlockRequestASOO = 18,
}
